export const USERDOCS = {
    PETITIONER: ['help/Petitioner/1_platform_overview.html',
        'help/Petitioner/2_petitioner_userguide.html',
        'help/Petitioner/3_petition_builder.html',
        'help/Petitioner/4_template_builder.html',
        'help/Petitioner/5_petitioner_cheatsheet.html',
        'help/Petitioner/6_applying for a green card_v2.html',
        'help/Petitioner/7_applying for a l-1 visa.html',
        'help/Petitioner/8_applying_for_e_visa.html',
        'help/Petitioner/9_applying_for_o_visa.html',
        'help/Petitioner/10_applying_for_tn_visa.html'

    ],
    PETITIONER_MENU: ['Platform Overview',
        'Petitioner Userguide',
        'Petition Builder',
        'Template Builder',
        'Petitioner Cheatsheet',
        'Applying for a Green Card',
        'Applying for L-1 Visa',
        'Applying for E Visa',
        'Applying for O Visa',
        'Applying for TN Visa'


    ],

    ATTORNEY: ['help/Attorney/1_platform_overview.html',
        'help/Attorney/2_attorney_userguide.html',
        'help/Attorney/3_petition_builder.html',
        'help/Attorney/4_template_builder.html',
        'help/Attorney/5_attorney_cheatsheet.html',
        'help/Attorney/6_rfe_response_builder.html',
        'help/Attorney/6a_applying for a green card_v2.html',
        'help/Attorney/7_applying for a l-1 visa.html',
        'help/Attorney/8_applying_for_e_visa.html',
        'help/Attorney/9_applying_for_o_visa.html',
        'help/Attorney/10_applying_for_tn_visa.html'
        

    ],
    ATTORENY_MENU: ['Platform Overview',
        'Lawfirm Userguide',
        'Petition Builder',
        'Template Builder',
        'Lawfirm Cheatsheet',
        'RFE Response Builder',
        'Applying for a Green Card',
        'Applying for L-1 Visa',
        'Applying for E Visa',
        'Applying for O Visa',
        'Applying for TN Visa'
    ],


    BENEFICIARY: ['help/Beneficiary/1_platform_overview.html',
        'help/Beneficiary/2_beneficiary_user_guide.html',
        'help/Beneficiary/3_beneficiary_cheatsheet.html'
    ],
    BENEFICIARY_MENU: ['Platform Overview',
        'Beneficiary Userguide',
        'Beneficiary Cheatsheet',
    ],
}


